import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ItemTypesActions } from './item-types.actions';
import { ItemTypesSelectors } from './item-types.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ItemType} from '@emm/core/models/item-type.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {SearchFilter} from '@emm/core/models/search-filter';
import {State as CoreState} from '@emm/core/store/core.reducer';

export interface ItemTypesQueries extends AsyncActionQueries {
    all$: Observable<ItemType[]>;
    selected$: Observable<ItemType>;
}

@Injectable({
    providedIn: 'root'
})
export class ItemTypesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    dispatch = {
        selectItemType: (tag: string) => this.store.dispatch(ItemTypesActions.select({ tag })),
        searchItemTypes: (filter: SearchFilter) =>
            this.store.dispatch(ItemTypesActions.searchItemTypes({ filter })),
        openAddItemTypeDialog: () => this.store.dispatch(ItemTypesActions.openAddDialog()),
        deleteItemType: (itemType: ItemType) =>
            this.store.dispatch(ItemTypesActions.delete({ itemType }))
    };

    queries: ItemTypesQueries = {
        all$: this.selectNonNil(ItemTypesSelectors.getFilteredItemTypes),
        selected$: this.selectNonNil(ItemTypesSelectors.getSelected),
        ...this.asyncActionQueries
    };

    constructor(store: Store<CoreState>) {
        super(store, ItemTypesSelectors);
    }

}
